import { Button } from 'antd';
import { useEffect, useMemo } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import ImageContainer from '../../General/ImageContainer';

const buttonStyle = {
    backgroundColor: 'white',
    width: '45px',
    height: '28px',
};

const iconStyle = {
    width: '12px',
    paddingBottom: '6px'
}

const SignatureInput = props => {
    const { def, data, onChange } = props;
    let _canvas = useMemo(() => { }, []);

    const signatureDone = () => {
        onChange(def.dataKey, _canvas.toDataURL());
    }

    const signatureClear = () => {
        _canvas.clear();
        onChange(def.dataKey, '');
    }

    useEffect(() => {
        if (data) _canvas.fromDataURL(data);
        
    }, []);

    return <div style={{ display: "flex", flexDirection: "row" }} data-input='signatureinput_de'>
        <div style={{ border: "1px solid black", marginRight: "5px" }}>
            <SignatureCanvas
                penColor='black'
                canvasProps={{ width: 400, height: 75 }}
                ref={ref => { _canvas = ref }}
                onEnd={signatureDone}
            />
        </div>
        <div>
            <Button style={buttonStyle} onClick={signatureClear} className='button_de'>
                <ImageContainer iconName='xmark' styles={iconStyle} className='fontawesomeTextGrey' />
            </Button>
        </div>
    </div>

}

export default SignatureInput;
